import { rem, Text, TextProps } from 'affiny-ui/src';
import React from 'react';

interface IPersonalityReportLayerParagraph {
  style?: Omit<TextProps, 'color'>;
  children: string;
}

export const PersonalityReportLayerParagraph = ({
  children,
  style = {},
}: IPersonalityReportLayerParagraph) => (
  <Text
    fontSize={rem(18)}
    mb={children.length > 80 ? 'large' : 'xSmall'}
    {...style}
  >
    {children}
  </Text>
);
